import React,{useState} from 'react';
import Switch from '@material-ui/core/Switch';
import {Howl , Howler} from "howler"
import song from "./song/sliceOfLife.mp3";


const musicButton =()=>{
   
  var sound =new Howl({
    src:[song],
  
  })
  
  const  soundHandler=()=>{
    if (!sound.playing()){
      sound.play();
    }
    else{
      sound.pause()
    }
  }


  Howler.volume(1.0)
  return(
       <Switch  
     color="primary"
     onClick={soundHandler} />
      
     
  )
}
export default musicButton


// WEBPACK FOOTER //
// ./src/UI/musicButton/sliceOfLife.jsx